// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AuthHeaderCmp$PorterinFeature from "./AuthHeaderCmp.mjs";
import * as AuthLayoutModuleScss from "../../styles/AuthLayout.module.scss";

var styles = AuthLayoutModuleScss;

function AuthLayout(Props) {
  var children = Props.children;
  var show_headerOpt = Props.show_header;
  var is_modalOpt = Props.is_modal;
  var close_modal = Props.close_modal;
  var show_header = show_headerOpt !== undefined ? show_headerOpt : false;
  var is_modal = is_modalOpt !== undefined ? is_modalOpt : false;
  return React.createElement("div", {
              className: styles.layout
            }, show_header ? React.createElement(AuthHeaderCmp$PorterinFeature.make, {
                    show_close_icon: is_modal,
                    close_modal: close_modal
                  }) : null, children);
}

var make = AuthLayout;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
